"use strict";

exports.__esModule = true;
var _LoadingMediator = require("./LoadingMediator");
Object.keys(_LoadingMediator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoadingMediator[key]) return;
  exports[key] = _LoadingMediator[key];
});